import { getCsrfToken } from '../../utils/helpers.js';

export const REVIEW_SUBMIT_ERROR = 'Something went wrong. Please try again.';

function getSnaptchaField(rootElement) {
    return rootElement?.querySelector('[data-snaptcha-field] input[name]') || null;
}

async function refreshSnaptchaField(rootElement) {
    const field = getSnaptchaField(rootElement);

    if (!field) {
        return;
    }

    try {
        const response = await fetch('/actions/snaptcha/field/get-field', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!response.ok) {
            return;
        }

        const data = await response.json();

        if (data?.name && typeof data.value === 'string') {
            field.name = data.name;
            field.value = data.value;
        }
    } catch (e) {
        // Ignore refresh failures and preserve the current submission error.
    }
}

export async function postReview(url, payload, rootElement = null) {
    const csrf = await getCsrfToken();
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    };
    const snaptchaField = getSnaptchaField(rootElement);
    const requestPayload = { ...payload };

    if (csrf) {
        headers['X-CSRF-Token'] = csrf.value;
    }

    if (snaptchaField?.name) {
        requestPayload[snaptchaField.name] = snaptchaField.value;
    }

    const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(requestPayload),
    });

    let data = null;

    try {
        data = await response.json();
    } catch (e) {
        data = {
            success: false,
            error: REVIEW_SUBMIT_ERROR,
        };
    }

    if (!data?.success) {
        await refreshSnaptchaField(rootElement);
    }

    return data;
}
